<template>
    <div
        v-if="list && list.length > 0"
        class="md-featured-area layout7 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            'background-color': bgColor
        }"
    >
        <div
            class="featured-area-container"
            ref="areaContainer"
        >
            <div class="left-content">
                <site-title
                    class="featured-area-title f-col"
                    :size="34"
                    :mbSize="20"
                    :title="title"
                    v-animated="textAnimation"
                />
                <div class="list-wrap">
                    <div 
                        class="list-item" 
                        :class="{ active: index === activeIndex, 'isShow': !isLess }"
                        v-for="(item, index) in list"
                        :key="index"  
                        @mouseenter="onAreaHover(index, item)"
                    >
                        <a
                            class="featured-area-item"
                            :href="item?.url"
                            rel="noopener noreferrer"
                        >
                            <div class="item-left">
                                <img-box
                                    v-if="item?.backPic"
                                    class="featured-area-item-preview"
                                    :src="item?.backPic"
                                    :alt="item.name"
                                    dir="height"
                                />
                                <div v-else class="default-wrap">
                                    <site-img
                                        :src="defaultImgSrc"
                                        :alt="item.name"
                                        dir="width"
                                    /> 
                                </div>
                                <site-sub-title
                                    class="featured-area-item-title"
                                    :size="18"
                                    :mbSize="18"
                                    :title="$ft.first(item.name)"
                                    align="left"
                                />
                            </div>
                            <div class="item-right">
                                <i class="iconfont icon-arrow_06_right"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="btn-more" v-if="isMobileSize && list.length > 10" @click="toggle">
                    {{ buttonText }}
                </div>
                <div
                    class="more-button-wrap"
                    v-if="showMoreButton"
                >
                    <site-button
                        :html="moreButtonText"
                        :href="moreButtonLink"
                        :target="moreButtonTarget"
                        type="plain"
                        rel="noopener noreferrer"
                        class="more-button"
                    />
                </div>
            </div>
            <div class="right-content" v-if="!isMobileSize">
                <component
                    :is="mapType"
                    v-if="loadMap && curArea?.label"
                    @mapLoad="mapLoad"
                    :address="curArea?.label"
                    :center="center"
                    :makeAddressCenter="false"
                    :tools="showTools"
                    :markerData="markerData"
                    :mapConfig="mapConfig"
                    :class="'layout7'"
                    :theme="'layout1'"
                />
                <div class="defaultImg" v-if="!curArea?.label">
                    <site-img :src="defaultMapSrc" dir="64" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '../index.js';

import { usePageStore } from '@/store';
import { mapState as rootMapState } from 'pinia';
import { defineAsyncComponent } from 'vue';
import { BOUNDARY_TYPE_MAP } from "@/common/constants/area-types.js"
export default {
    mixins: [common],
    components: {
        Map: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map_broker"*/ '@/components/map/broker.vue'
            )),
        hereMap: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map-here_broker"*/ '@/components/map-here/broker.vue'
            ))
    },
    data() {
        return {
            defaultImgSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/default-img.png',
            mapFullscreen: false,
            loadMap: false,
            defaultMapSrc: 'https://cdn.chime.me/image/fs/sitebuild/2024923/6/original_765bbef7-6434-47e4-98d3-6aa01be1a406.png',
            mapConfig: {
                mapTypeId: 'roadmap',
                scrollwheel: false,
                mapTypeControl: false
            },
            mapTools: [
                {
                    name: 'zoom',
                    css: 'right: 20px; bottom: 20px; width:40px; height: 80px; color:#191919;'
                },
                {
                    name: 'maptype',
                    css: 'left: 20px; bottom: 20px; border: 0',
                    icon: 'icon-a-Zoominandout'
                },
                {
                    name: 'fullscreen',
                    css: 'width: 40px; height: 40px; right: 20px; top: 20px; box-shadow: 0 10px 15px 0 rgba(170, 186, 218, 0.3); color: #191919; border-radius: 4px;line-height: 40px; font-size: 18px;',
                    icon: 'icon-a-fullscreen'
                }
            ],
            mobileMapTools: [
                {
                    name: 'zoom',
                    css: 'right: 20px; bottom: 20px; width: 30px; height: 60px; border-radius: 4px; box-shadow: unset; color:#191919'
                },
                {
                    name: 'maptype',
                    css: 'left: 20px; bottom: 20px; width: 30px; height: 30px; box-shadow: unset; border-radius: 4px; color:#191919;'
                }
            ],
            markerData: {
                location: {
                    address: this.curArea?.label
                }
            },
            curArea: null,
            activeIndex: 0,
            boundaryColor: 'rgba(25, 25, 25, 1)',
            isLess: true,
            getBoundaryPsMap: {}
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            mapType: store =>
                store.page?.map?.type === 'google' ? 'Map' : 'hereMap',
        }),
        buttonText() {
            return  this.isLess ? 'More' : 'Less'; 
        },
        showTools() {
            return this.isMobileSize ? this.mobileMapTools : this.mapTools;
        },
        center() {
            var latlng = (this.centerPoint || '').split(',');
            if (latlng.length === 2) {
                return {
                    lat: latlng[0],
                    lng: latlng[1]
                };
            } else {
                return null;
            }
        },
    },
    watch: {
        list: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.curArea = newVal[0];
            }
        },
        'curArea?.label'() {
            this.updateLocationMarker();
        },
        center(a) {
            a && this.updateLocationMarker();
        },
    },
    created() {
        //  Define map module loading 
        this.psMap = new Promise(resolve => {
            this.psResolve = resolve;
        });
    },
    mounted() {
        this.$nextTick(() => {
            this.loadMap = true;
        }); 
    },
    methods: {   
        mapLoad(siteMap, map, maps) {
            this.siteMap = siteMap;
            this.map = map;
            this.maps = maps;
            this.psResolve(siteMap);
            this.updateLocationMarker();
            this.getBoundary(this.curArea);
        },
        updateLocationMarker() {
            this.psMap.then(() => {
                this.markerData = Object.assign({}, this.markerData, {
                    location: this.curArea?.label
                        ? {
                            address: this.curArea?.label,
                            ...(this.center || this.siteMap.config.center)
                        }
                        : null
                });
            });
        },
        onAreaHover(index, curItem) {
            this.curArea = curItem
            this.activeIndex = index;
            // this.updateLocationMarker();
            this.getBoundary(curItem);
        },
        toggle() {
            this.isLess = !this.isLess;
        },
        getBoundary(curItem) {
            if (!curItem.label) {
                return; 
            }
            let type = BOUNDARY_TYPE_MAP[curItem.areaType] || BOUNDARY_TYPE_MAP['1']
            let url = `/api-site/hjNbrConfig/boundary?type=${type}&name=${curItem?.label.replace(
                /\s/g,
                '+'
            )}`;
            if (!this.getBoundaryPsMap[url]) {
                this.getBoundaryPsMap[url] = this.axiosIns.get(url, {
                    cancelKey: '/api-site/hjNbrConfig/boundary'
                }).catch(() => {
                    this.getBoundaryPsMap[url] = null;
                    this.updateLocationMarker();
                })
            }

            this.getBoundaryPsMap[url].then(res => {
                if (this.curArea === curItem) {
                    this.updateLocationMarker();
                    console.log('this.mapBoundary--------------', res)
                    if (res?.boundary?.data?.length) {
                        this.showBoundary(res.boundary, !curItem._hasBoundary);
                        curItem._hasBoundary = true;
                    } else {
                        console.warn('no boundary data');
                    }
                }
            })
        },
        showBoundary(boundary, addBoundary) {
            this.siteMap?.addBoundary(boundary, this.boundaryColor, { clear: true });
            this.siteMap?.fitBoundary(0, null, false);
        },
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-featured-area.layout7 {
    .featured-area-container {
        display: flex;
        height: auto;
    }

    .left-content {
        width: 50%;
        padding: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: calc((100% - var(--module-width)) / 2);
        @include media-1440 {
            padding-left: 50px;
        }
        @include media-1080 {
            padding-left: 40px;
        }
        @include media-840 {
            padding-left: 40px;
        }
    }
    
    .featured-area-title {
        margin-bottom: 40px;
    }

    .list-wrap {
        display: flex;
        flex-wrap: wrap;
        column-gap: 40px;
        row-gap: 30px;
        overflow-y: auto;
        position: relative;
        width: calc(100% + 44px);
        left: 0;
        padding-right: 44px;
        max-height: 500px;

        &::-webkit-scrollbar {
            width: 6px;
        }
        &::-webkit-scrollbar-track {
            background: transparent;
            border-radius: 6px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 6px;
            position: relative;
            display: block;
            width: 0;
            height: 0;
            cursor: pointer;
            background-color: rgba(144, 147, 153, 0.3);
            -webkit-transition: 0.3s background-color;
            transition: 0.3s background-color;
        }
    }

    .list-item {
        width: calc((100% - 40px) / 2);
        height: auto;
        padding-bottom: 6px;
        position: relative;
        text-decoration: none;
        transition: all .3s ease;
        &:before,
        &:after {
            content: "";
            display: block;
            width: 0;
            height: 1px;
            background: var(--g-primary-color);
            position: absolute;
            left: 0;
            bottom: 0;
            transition: .3s ease;
        }
        &:before {
            width: 100%;
            opacity: 0.5;
        }

        .featured-area-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;

            .item-left {
                width: calc(100% - 10px - 16px);
                display: flex;
                align-items: center;
                gap: 10px;
            }
            .item-right {
                transition: all .3s ease;
                .iconfont {
                    font-size: 16px;
                    color: var(--g-tip-color);
                }
            }

            .featured-area-item-preview {
                width: 40px;
                height: 40px;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                } 
            }
            .default-wrap {
                width: 40px;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden; 
                background: rgba(218, 218, 218, 0.2);
                img {
                    width: 16px;
                    height: 14px;
                    object-fit: contain;
                    opacity: 0.3;
                }
            }
            .featured-area-item-title {
                font-family: var(--font-light);
                font-size: 18px;
                line-height: 1.5;
                font-weight: 400;
                color: var(--g-primary-color);
                width: calc(100% - 40px - 10px);
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }

        &:hover {
            &::after {
                width: 100%;
            }
            .featured-area-item {
                .item-right {
                    transform: rotate(-45deg);
                    .iconfont {
                        color: var(--g-primary-color); 
                    }
                }
            }
        }
    }

    .btn-more {
        margin: 20px auto 0 auto;
        text-align: center;
        color: var(--g-text-color);
        font-size: 14px;
        line-height: 1.8;
        font-weight: 400;
        cursor: pointer;
        text-decoration: underline;
    }

    .more-button-wrap{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 30px;
        @include media-840 {
            margin-top: 20px;
        }
        .more-button {
            width: calc((100% - 30px) / 2);
            height: 50px;
            @include media-840 {
                width: 100%;
            }
        }
    }

    .right-content {
        width: 50%;
        height: 700px;
        .site-map {
            width: 100%;
            height: 100%;

            .icon-a-fullscreen,
            .map-type {
                display: none;
            }
            .map-tool.mobile-map-type {
                line-height: 30px;
            }
        }

        .defaultImg {
            width: 100%;
            height: 100%;
            background: var(--Border-Line, rgba(218, 218, 218, 0.2));
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                width: 64px;
                height: 64px;
            }
        }
    }

    @include media-800 {
        .featured-area-container {
            height: auto;
        }
        .featured-area-title {
            margin-bottom: 20px;
        }
        .left-content {
            width: 100%;
            padding: 0 15px;
        }
        .list-wrap {
            width: 100%;
            flex-direction: column;
            flex-wrap: nowrap;
            gap: 30px;
            position: static;
            padding-right: 0;
            max-height: none;
        }
        .list-item {
            width: 100%;

            &:nth-child(n + 11) {
                display: none;
            }
            &.isShow {
                display: block;
            }
        }
    }
}
</style>
